import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ExistingSupplierMatch,
  SupplierCreateChoice,
  matchReasonLabel,
} from 'src/app/shared/models/existing-supplier-match.model';

export interface ExistingSupplierChoiceData {
  matches: ExistingSupplierMatch[];
  /** False when the typed e-mail already belongs to a supplier: a second account cannot be made for it. */
  allowCreateNew: boolean;
}

/**
 * "Already on MPS" choice before a supplier is created (2026-10-20).
 *
 * Shown by ExistingSupplierCheckService on every supplier create screen that has no inline choice of its own. The
 * buyer links one of the existing suppliers (no new account, no e-mail), or - only behind a second, explicit
 * confirm - creates a new one anyway. Closes with a SupplierCreateChoice, or null when cancelled.
 */
@Component({
  selector: 'app-existing-supplier-choice',
  templateUrl: './existing-supplier-choice.component.html',
  styleUrls: ['./existing-supplier-choice.component.css'],
})
export class ExistingSupplierChoiceComponent {
  confirmingCreate = false;
  reasonLabel = matchReasonLabel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ExistingSupplierChoiceData,
    private dialogRef: MatDialogRef<ExistingSupplierChoiceComponent, SupplierCreateChoice | null>
  ) {}

  link(match: ExistingSupplierMatch): void {
    this.dialogRef.close({ linkSupplierId: match.supplierId, linkedName: match.companyName });
  }

  createNew(): void {
    this.dialogRef.close({ createNew: true });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  trackByMatch(_i: number, m: ExistingSupplierMatch): number {
    return m.supplierId;
  }
}
